/**
 * Shared dispatch utilities for RTK Query
 */
import { store } from '../../../app/store';
import { UpdatePayload } from '../models';

/**
 * Helper to dispatch RTK Query mutations and get the result
 */
export async function dispatchMutation<T>(
  endpoint: any,
  payload: UpdatePayload<any>,
  options?: { signal?: AbortSignal },
): Promise<T> {
  try {
    const result = await store
      .dispatch(endpoint.initiate(payload, options))
      .unwrap();
    return result as T;
  } catch (error: any) {
    const enhancedError: any = new Error(
      error?.data?.message || error?.message || 'API Error',
    );
    enhancedError.status = error?.status;
    enhancedError.statusText = error?.statusText || error?.data;
    enhancedError.data = error?.data;
    throw enhancedError;
  }
}

/**
 * Helper to dispatch RTK Query queries and get the result
 */
export async function dispatchQuery<T>(
  endpoint: any,
  arg: any,
  options?: { forceRefetch?: boolean; signal?: AbortSignal },
): Promise<T> {
  try {
    const result = await store.dispatch(
      endpoint.initiate(arg, {
        ...options,
        forceRefetch: true,
      }),
    );
    if ('error' in result) {
      const error: any = new Error(
        result.error?.data?.message || result.error?.status || 'API Error',
      );
      error.status = result.error?.status;
      error.statusText = result.error?.statusText;
      error.data = result.error?.data;
      throw error;
    }
    return result.data as T;
  } catch (error: any) {
    if (error.status) throw error;
    const enhancedError: any = new Error(
      error?.data?.message || error?.message || 'API Error',
    );
    enhancedError.status = error?.status;
    enhancedError.statusText = error?.statusText || error?.data;
    enhancedError.data = error?.data;
    throw enhancedError;
  }
}
